"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCustomSchemeWrapper = exports.StyledCustomSchemeButtonWrapper = exports.StyledSchemeColors = exports.StyledSchemeName = exports.StyledSchemeInfo = exports.StyledCardBox = exports.StyledSchemesCard = exports.StyledSchemesCardWrapper = exports.StyledSchemesContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _style = _interopRequireDefault(require("../../styles-common/color-input/style"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var StyledSchemesContainer = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledSchemesContainer",
  componentId: "sc-1efy3cc-0"
})(["position:relative;width:100%;margin-left:-5px;margin-right:-5px;padding-top:10px;*{box-sizing:border-box;}"]);

exports.StyledSchemesContainer = StyledSchemesContainer;

var StyledSchemesCardWrapper = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledSchemesCardWrapper",
  componentId: "sc-1efy3cc-1"
})(["display:flex;flex-wrap:wrap;justify-content:space-between;"]);

exports.StyledSchemesCardWrapper = StyledSchemesCardWrapper;

var StyledSchemesCard = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledSchemesCard",
  componentId: "sc-1efy3cc-2"
})(["flex-basis:calc((100% / 3) - (20px / 3));margin:0 5px 10px;&:nth-of-type(3n + 1){margin-left:0;}&:nth-of-type(3n + 3){margin-right:0;}&:last-of-type{margin-right:auto;}input{display:none;}"]);

exports.StyledSchemesCard = StyledSchemesCard;

var StyledCardBox = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledCardBox",
  componentId: "sc-1efy3cc-3"
})(["width:100%;box-sizing:border-box;height:100px;border:", ";border-radius:4px;background-color:rgba(255,255,255,1);padding:15px 18px;&:hover{border:2px solid #c32d7b;cursor:pointer;}"], function (props) {
  return props.active ? "2px solid #C32D7B" : "1px solid rgba(202,204,208,0.85)";
});

exports.StyledCardBox = StyledCardBox;

var StyledSchemeInfo = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledSchemeInfo",
  componentId: "sc-1efy3cc-4"
})([""]);

exports.StyledSchemeInfo = StyledSchemeInfo;

var StyledSchemeName = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledSchemeName",
  componentId: "sc-1efy3cc-5"
})(["font-size:14px;margin:0;padding-bottom:7px;text-transform:uppercase;"]);

exports.StyledSchemeName = StyledSchemeName;

var StyledSchemeColors = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledSchemeColors",
  componentId: "sc-1efy3cc-6"
})(["div{height:21px;}"]);

exports.StyledSchemeColors = StyledSchemeColors;

var StyledCustomSchemeButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledCustomSchemeButtonWrapper",
  componentId: "sc-1efy3cc-7"
})(["position:absolute;top:-40px;right:0;"]);

exports.StyledCustomSchemeButtonWrapper = StyledCustomSchemeButtonWrapper;

var StyledCustomSchemeWrapper = _styledComponents["default"].fieldset.withConfig({
  displayName: "style__StyledCustomSchemeWrapper",
  componentId: "sc-1efy3cc-8"
})(["margin-top:20px;border:0;legend{margin-bottom:10px;color:#393f44;font-weight:700;font-size:13px;}.container{display:flex;flex-wrap:wrap;justify-content:space-between;", "{margin:0 5px 10px;margin-bottom:10px;flex-basis:calc((100% / 3) - (20px / 3));&:nth-of-type(3n + 1){margin-left:0;}&:nth-of-type(3n + 3){margin-right:0;}&:last-of-type{margin-right:auto;}}}"], _style["default"]);

exports.StyledCustomSchemeWrapper = StyledCustomSchemeWrapper;